import { render } from "./GlobalCurrencyIcon.vue?vue&type=template&id=e541b40a&ts=true"
import script from "./GlobalCurrencyIcon.vue?vue&type=script&lang=ts"
export * from "./GlobalCurrencyIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__